import React from "react";
import { TransProps } from "@lingui/react";

export type typeButtonLink = {
  id?: string;
  dark?: boolean;
  name?: string;
  variant?: string;
  disabled?: boolean;
  type: "submit" | "button";
  buttonClassName?: string;
  label: React.ReactElement<TransProps>;
  onClick?: (e: React.MouseEvent | React.TouchEvent) => void;
};

export const ButtonLink: React.FC<typeButtonLink> = ({
  id,
  dark,
  name,
  type,
  label,
  onClick,
  buttonClassName,
  disabled = false,
}) => {
  let buttonStyles = [
    `${dark ? "text-white" : `text-${disabled ? "gray-400" : "indigo-600"}`} focus:outline-none focus:ring-0${disabled ? "" : " hover:underline"}`,
    buttonClassName,
  ].join(" ");

  return (
    <button
      id={id}
      name={name}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={buttonStyles}
    >
      {label}
    </button>
  );
};
